import { Survey } from '../../survey.class';
import { getPropertyDescriptor } from '../../../../functions';

const type = 'default';


let OptionSupportedQuestionTypes = getPropertyDescriptor(Survey.prototype, 'supportedQuestionTypes');
Object.defineProperties(Survey.prototype, {
  supportedQuestionTypes:{
    get: function(): boolean {
        return OptionSupportedQuestionTypes.get.apply(this).concat(['radio','checkbox','text','table-checkbox']);
    }    
  },
})

let SurveyAddQuestion = Survey.prototype.addQuestion;
Survey.prototype.addQuestion = function(...args) {
  args[0] = {type:'radio', ...args[0]};
  return SurveyAddQuestion.apply(this, args);
};
console.log("survey type default is added");